interface EmptyResultProps {
  searchText: string;
}

export const EmptyResult = ({ searchText }: EmptyResultProps) => {
  return (
    <section className="w-full lg:mt-8 -mt-4">
      <div className="w-auto m-[auto] flex justify-center lg:items-center gap-4">
        <div className="w-[124px] h-full flex justify-center">
          <p className="text-[96px] text-primary-medium whitespace-nowrap">
            :(
          </p>
        </div>
        <div className="w-auto h-full">
          <h1 className="text-2xl text-primary-medium font-bold leading-8 mt-4 mb-3">
            {!searchText && 'Ops! Nenhum produto encontrado'}
            {searchText &&
              `Ops! nenhum resultado encontrado para '${searchText}'`}
          </h1>
          <p className="text-base text-gray-dark font-normal leading-normal mt-2 mb-1 -ml-12 lg:ml-0">
            O que eu faço?
          </p>
          <ol className="pl-8 -ml-12 lg:ml-0">
            <li className="text-base text-gray-dark font-normal leading-normal my-2">
              &#8226; Verifique os termos digitados ou os filtros selecionados.
            </li>
            <li className="text-base text-gray-dark font-normal leading-normal my-2">
              &#8226; Utilize termos genéricos na busca.
            </li>
            <li className="text-base text-gray-dark font-normal leading-normal my-2">
              &#8226; Tente outra vez com termos menos específicos
            </li>
          </ol>
        </div>
      </div>
    </section>
  );
};
